import {
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalTitle,
} from '@cambridgeassessment/cambridge-ui';
import { Box, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import useOrgUserDetails from 'src/hooks/useOrgUserDetails';
import { useStyles } from './styles';
import { getFullName } from './utils';

const ActivateUser: React.FC = () => {
  const [open, setOpen] = useState<boolean>(false);

  const { activateUser, userDetails } = useOrgUserDetails();
  const name = getFullName(userDetails.firstName, userDetails.lastName);

  const openModal = () => setOpen(true);
  const closeModal = () => setOpen(false);

  const classes = useStyles();

  return (
    <>
      <Button
        color="primary"
        onClick={openModal}
        data-testid="open-confirmation-modal"
      >
        Activate user
      </Button>

      <Modal
        open={open}
        size="small"
        onClose={closeModal}
        data-testid="confirmation-modal"
      >
        <Box className={classes.modalTitle}>
          <ModalTitle onClose={closeModal} data-testid="confirmation-header">
            {`Activate ${name}?`}
          </ModalTitle>
        </Box>
        <ModalContent>
          <Typography
            variant="body1"
            className={classes.modalText}
            data-testid="confirmation-body"
          >
            Are you sure you want to make{' '}
            {name === 'user' ? name : <strong>{name}</strong>} active in your
            organisation?
            <br />
            <br />
            This will give them access to the services your organisation
            subscribes to and the roles they held previously (these can be
            changed in the manage user screen).
          </Typography>
        </ModalContent>
        <ModalActions>
          <Button
            onClick={closeModal}
            color="primary"
            variant="text"
            data-testid="cancel-confirmation-modal"
          >
            Cancel
          </Button>
          <Button
            onClick={activateUser}
            color="primary"
            data-testid="confirm-confirmation-modal"
          >
            Activate user
          </Button>
        </ModalActions>
      </Modal>
    </>
  );
};
export default ActivateUser;
